import { render } from "./PaymentDetailModal.vue?vue&type=template&id=20fa67b4&scoped=true"
import script from "./PaymentDetailModal.vue?vue&type=script&lang=js"
export * from "./PaymentDetailModal.vue?vue&type=script&lang=js"

import "./PaymentDetailModal.vue?vue&type=style&index=0&id=20fa67b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fa67b4"]])

export default __exports__